import PageLayout from './PageLayout';
import { TravelSection } from '@/components/wedding';

const TravelPage = () => (
  <PageLayout testId="travel-page">
    <TravelSection />
  </PageLayout>
);

export default TravelPage;
